import React, { useEffect, useContext, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ISwapFees } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getSwapFeesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_fees_by_chain', timeframe)) as ISwapFees[]
	const btcData = chartData.filter((row) => row.CHAIN === 'BTC')
	const ethData = chartData.filter((row) => row.CHAIN === 'ETH')
	const bchData = chartData.filter((row) => row.CHAIN === 'BCH')
	const avaxData = chartData.filter((row) => row.CHAIN === 'AVAX')
	const baseData = chartData.filter((row) => row.CHAIN === 'BASE')
	const dogeData = chartData.filter((row) => row.CHAIN === 'DOGE')
	const ltcData = chartData.filter((row) => row.CHAIN === 'LTC')
	const atomData = chartData.filter((row) => row.CHAIN === 'GAIA')
	const tcData = chartData.filter((row) => row.CHAIN === 'THOR')
	const bscData = chartData.filter((row) => row.CHAIN === 'BSC')
	const xrpData = chartData.filter((row) => row.CHAIN === 'XRP')
	const tronData = chartData.filter((row) => row.CHAIN === 'TRON')
	const zecData = chartData.filter((row) => row.CHAIN === 'ZEC')

	const series1 = btcData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series2 = ethData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series3 = bchData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series4 = avaxData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series5 = baseData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series6 = dogeData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series7 = ltcData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series8 = atomData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series9 = tcData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series11 = bscData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series10 = btcData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_FEES_USD }
	})
	const series12 = xrpData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series13 = tronData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const series14 = zecData.map((element: ISwapFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_FEES_USD }
	})
	const config: IChart[] = [
		{
			data: series10,
			strokeWidth: 2,
			name: 'CUMULATIVE',
			type: 'line',
			seriesGroup: ' [usd]',
			color: `${color}`,
			unitSymbol: '$'
		},

		{
			data: series1,
			strokeWidth: 2,
			name: 'BTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'ETH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'THOR',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BCH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'AVAX',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series11,
			strokeWidth: 2,
			name: 'BSC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'DOGE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'LTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'ATOM',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[8]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'BASE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[9]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'XRP',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[10]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series13,
			strokeWidth: 2,
			name: 'TRON',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[11]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series14,
			strokeWidth: 2,
			name: 'ZEC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[13]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		}
	]
	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const SwapFees = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getSwapFeesConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Swap Fees By Chain"
			chartDesc={`Liquidity fees paid by swappers, broken down by the external chain of the pool involved. Shows which chains generate the most fee revenue.\nBSC includes both BSC and BNB chains.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="fd202dfe-5142-47fe-a5ee-8e230d481617"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default SwapFees
